import { useEffect, useRef } from "react";

/**
 * useReveal — attach to an element to fade it in on scroll.
 * Usage: const ref = useReveal(); <div ref={ref} className="reveal"/>
 */
export const useReveal = (options = {}) => {
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: options.threshold ?? 0.15, rootMargin: options.rootMargin ?? "0px 0px -60px 0px" }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [options.threshold, options.rootMargin]);
  return ref;
};
